import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    admin: Cookies.get('admin_user') ? JSON.parse(Cookies.get('admin_user')) : null,
    token: Cookies.get('admin_token') || null
  },

  mutations: {
    SET_ADMIN(state, admin) {
      state.admin = admin
      if (admin) {
        Cookies.set('admin_user', JSON.stringify(admin), { expires: 7 })
      } else {
        Cookies.remove('admin_user')
      }
    },

    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        Cookies.set('admin_token', token, { expires: 7 })
      } else {
        Cookies.remove('admin_token')
      }
    },

    LOGOUT(state) {
      state.admin = null
      state.token = null
      Cookies.remove('admin_user')
      Cookies.remove('admin_token')
    }
  },

  actions: {
    login({ commit }, { admin, token }) {
      commit('SET_ADMIN', admin)
      commit('SET_TOKEN', token)
    },

    logout({ commit }) {
      commit('LOGOUT')
    },

    async getAdminInfo({ commit }) {
      try {
        const { getAdminInfo } = await import('@/api/auth')
        const response = await getAdminInfo()
        if (response.code === 200) {
          commit('SET_ADMIN', response.data)
          return response.data
        }
      } catch (error) {
        console.error('获取管理员信息失败:', error)
        throw error
      }
    }
  },

  getters: {
    isLoggedIn: state => !!state.token,
    currentAdmin: state => state.admin
  }
})
